import conf from '../../conf';
export const getAPIConnectorDetails = (connectors) => {
    const ApiConnector = connectors.filter(c => c.id === 'a0n4000000ChMxlAAF')[0];
    const ApiConnectorCopy = Object.assign({}, ApiConnector);
    ApiConnectorCopy.logo = `${conf.ASSET_PATH}/assets/images/avalara_logo.png`;
    return ApiConnectorCopy;
};
